import React, { useState, useEffect } from "react";

import TagsSelectCard from "components/Tags/TagsSelectCard";
import ValuesSelectCard from "components/Values/ValuesSelectCard";

import FormData from "./help/FormData";

import { useSettings } from 'utils/settings';

const Form = ({
    type = 'notch',
    selectedDate = null,
    notchTypes = [],
    addItemHandler,
    onCancelHandler,
    editingNotch
}) => {
    const [settings, setSettings] = useSettings();
    const [activeSection, setActiveSection] = useState('form');
    
    const [errors, setErrors] = useState({});
    const [form, setForm] = useState({
        favorite_uid: null,
        date: selectedDate,
        notch: "",
        note: "",
        type: "notch",
        color: null,
        private: true,
        quick_access: false,
        tags: [],
        values: []
    });

    useEffect(() => {
        if (editingNotch) {
            setForm({
                uid: editingNotch.uid,
                date: editingNotch.date,
                notch: editingNotch.notch,
                note: editingNotch.note || "",
                type: editingNotch.type || "notch",
                color: editingNotch.color || null,
                // private: editingNotch.private,
                quick_access: editingNotch.quick_access ?? null,
                tags: editingNotch.tags ? editingNotch.tags : [],
                values: editingNotch.values || []
            });
        }
     }, [editingNotch]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const formData = {
                ...form,
                tags: form.tags.map(tag => tag.uid),
                values: form.values.map(item => ({ uid: item.uid, value: item.value ?? item.payload.value }))
            };

            await addItemHandler(formData);
        } catch (error) {
            if (error.response.data.errors) {
                setErrors(error.response.data.errors);
            }
        }
    };

    const handleCancel = () => {
        onCancelHandler();
    };

    const handleAddValue = (item) => {
        setForm(prev => ({
            ...prev,
            values: [...prev.values, item]
        }));

        setActiveSection('form');
    };

    const handleSaveSelectedItem = (itemType, selectedItems) => {
        switch (itemType) {
            case 'tag':
                setForm(prev => ({
                    ...prev,
                    tags: selectedItems
                }));
                break;
        }

        setActiveSection('form');
    };

    function settingChangeHandler(section, settingId) {
        setSettings(prev => {
            const currentValue = prev['tags'][settingId];
            const value = settingId === 'sort'
                ? (currentValue === 'asc' ? 'desc' : 'asc')
                : !currentValue;

            return {
                ...prev,
                ['tags']: {
                    ...prev['tags'],
                    [settingId]: value
                }
            };
        });
    }

    const renderContent = () => {
        switch (activeSection) {
            case "values":
                return <ValuesSelectCard 
                    onClick={handleAddValue}
                    onCancel={() => setActiveSection('form')}
                />;
            case "tags":

                const tagsListSettings = {
                    'section': 'tags',
                    'items': {
                        'displayGroups': {
                            'label': 'Display groups',
                            'type': 'switch',
                            'checked': settings.tags.displayGroups
                        },
                    }
                };

                return <TagsSelectCard 
                    selectedItems={form.tags}
                    settings={tagsListSettings}
                    onSettingChange={settingChangeHandler}
                    onSave={handleSaveSelectedItem}
                    onCancel={() => setActiveSection('form')}
                />;
            case "form":
            default:
                return <FormData
                    form={form}
                    type={type}
                    errors={errors}
                    notchTypes={notchTypes}
                    onSubmit={handleSubmit}
                    onCancel={handleCancel}
                    setActiveSection={setActiveSection}
                    setForm={setForm}
                />;
        }
    };

    return (
        renderContent()
    );
};

export default Form;